import { valueOutputToPromise, wrapDeprecated } from "./helpers.js";
import _detectDomAdblocker from "./detectDomAdblocker.js";
import _detectAnyAdblocker from "./detectAnyAdblocker.js";
import _detectBraveShields from "./detectBraveShields.js";
import _detectOperaAdblocker from "./detectOperaAdblocker.js";

export const detectAnyAdblocker = _detectAnyAdblocker;
export const detectBraveShields = _detectBraveShields;
export const detectOperaAdblocker = _detectOperaAdblocker;

export const detectDomAdblocker = valueOutputToPromise(_detectDomAdblocker);

export const isDetected = wrapDeprecated(detectDomAdblocker, "The `isDetected()` method is now deprecated, please use `detectAnyAdblocker()` instead, which returns a Promise and can detect more stuff (like Brave Shields).");
